<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row class="fill-height align-center justify-center text-center">
      <v-col
        cols="12"
        md="8"
        sm="10"
      >
        <div class="text-center">
          <div class="">
            <v-icon
              color="brand-primary"
              size="196"
            >
              mdi-account-check
            </v-icon>
          </div>

          <div class="my-6">
            <v-avatar size="64">
              <img :src="LogoViva">
            </v-avatar>

            <v-icon class="mx-2">
              mdi-plus
            </v-icon>

            <v-avatar
              color="brand-primary"
              size="64"
            >
              <img
                :src="LogoMp"
                class="pa-1"
              >
            </v-avatar>
          </div>

          <h1>{{ $t('Common.Marketplace.Account.Connected.Title') }}</h1>

          <h4 class="font-weight-regular mt-4">
            {{ $t('Common.Marketplace.Account.Connected.Subtitle') }}
          </h4>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MarketplaceAccountConnectedMixin from '@/theme/default/views/marketplace/MarketplaceAccountConnected.js'

export default {
  name  : 'MarketplaceAccountConnected',
  mixins: [MarketplaceAccountConnectedMixin]
}
</script>

<style scoped src="@/theme/default/views/marketplace/MarketplaceAccountConnected.css"></style>
<style scoped>
</style>
